module.exports = __webpack_public_path__ + "static/media/main-page-img.e1c2e10e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main-page-img.png
// module id = 826
// module chunks = 0